import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
    transform(value: string | Date, lang: string = 'en'): string {
        const date = new Date(value);
        const options: Intl.DateTimeFormatOptions = {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        };
        return date.toLocaleDateString(lang, options).toUpperCase();
    }
}
